/**
 * Role Permission Repository
 * Handles all role-permission-related API calls
 */

import { apiClient } from '../client'

export interface RolePermission {
  id: number
  role_id: number
  permission_id: number
  status: number
  created_by?: number | null
  updated_by?: number | null
  created_at: Date
  updated_at: Date
}

class RolePermissionRepository {
  /**
   * Get all role-permissions
   */
  async getAll(): Promise<RolePermission[]> {
    return apiClient.get<RolePermission[]>('/role-permissions')
  }

  /**
   * Get role-permissions by role ID
   */
  async getByRoleId(roleId: number): Promise<RolePermission[]> {
    return apiClient.get<RolePermission[]>(`/role-permissions/role/${roleId}`)
  }

  /**
   * Get role-permission by ID
   */
  async getById(id: number): Promise<RolePermission> {
    return apiClient.get<RolePermission>(`/role-permissions/${id}`)
  }

  /**
   * Create a new role-permission
   */
  async create(data: {
    role_id: number
    permission_id: number
    status?: number
    created_by?: number
  }): Promise<RolePermission> {
    return apiClient.post<RolePermission>('/role-permissions', data)
  }

  /**
   * Update an existing role-permission
   */
  async update(id: number, data: {
    role_id?: number
    permission_id?: number
    status?: number
    updated_by?: number
  }): Promise<RolePermission> {
    return apiClient.put<RolePermission>(`/role-permissions/${id}`, data)
  }

  /**
   * Delete a role-permission
   */
  async delete(id: number): Promise<{ message: string }> {
    return apiClient.delete<{ message: string }>(`/role-permissions/${id}`)
  }
}

// Export singleton instance
export const rolePermissionRepository = new RolePermissionRepository()

